import { Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR, lightGrey } from 'utils/colors';
import {
    heightPercentageToDP,
    isTablet,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    topLogo: {
        alignSelf: 'center',
        marginBottom: Platform.select({ default: 16, web: 32 }),
        resizeMode: 'contain',
    },
    textStyle: {
        marginHorizontal: widthPercentageToDP(44),
        fontFamily: Fonts.main.regular,
        fontSize: 16,
        color: lightGrey(),
        textAlign: 'center',
        fontWeight: '400',
    },
    textMargin: {
        marginBottom: heightPercentageToDP(40),
    },
    emptyViewLoadingSpinner: {
        height: isTablet ? 48 : 32,
    },
    errorButtonTextStyle: {
        color: COLOR.background,
    },
});

export default styles;
